import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { ReactNode, useEffect, useState } from "react";
import { PrimaryButton, SecondaryButton } from "../";

interface BasicModalProps {
    title: string;
    open: boolean;
    onClose: () => void;
    children: ReactNode;
    saveButton?: boolean;
    onSave?: () => void;
    actions?: ReactNode;
    sizeContent?: "small" | "medium" | "large"
    onEdit?: () => void;
}

export default function BasicModal({
    title,
    open,
    onClose,
    children,
    saveButton,
    onSave,
    actions,
    sizeContent = "small",
    onEdit
}: BasicModalProps) {
    const [maxWidth, setMaxWidth] = useState<"sm" | "md" | "lg">("sm")

    useEffect(() => {
        if (sizeContent === "large") {
            setMaxWidth("lg");
        } else if (sizeContent === "medium") {
            setMaxWidth("md");
        }
    }, [])

    return (
        <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth>
            <DialogTitle sx={{ bgcolor: (theme) => theme.palette.primary.main, color: 'white' }}>
                {title}
            </DialogTitle>
            <DialogContent dividers>
                {children}
            </DialogContent>
            <DialogActions sx={{ paddingBlock: 1, paddingInline: 2 }}>
                {actions ? (
                    actions
                ) : (
                    <>
                        <SecondaryButton onClick={onClose}>Fechar</SecondaryButton>

                        {onEdit && !saveButton && (
                            <PrimaryButton onClick={onEdit}>
                                Editar
                            </PrimaryButton>
                        )}

                        {saveButton && onSave && (
                            <PrimaryButton onClick={onSave}>
                                Salvar
                            </PrimaryButton>
                        )}
                    </>
                )}
            </DialogActions>
        </Dialog>
    );
}